import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Chip,
  useTheme
} from '@mui/material';
import {
  Person as PersonIcon,
  CalendarMonth as CalendarIcon,
  BookOnline as BookingsIcon,
  CreditCard as SubscriptionIcon,
  Settings as SettingsIcon,
  HelpOutline as SupportIcon,
  Notifications as NotificationsIcon
} from '@mui/icons-material';

const DrawerNavigation = ({ currentTab, setCurrentTab, isMobile, setMobileOpen, userProfile, pendingBookingsCount = 0 }) => {
  const theme = useTheme();

  const tabs = [
    { 
      id: 0, 
      label: 'Mon Profil', 
      icon: PersonIcon,
      description: 'Gérez vos informations',
      color: '#3b82f6'
    },
    { 
      id: 1, 
      label: 'Mon Planning', 
      icon: CalendarIcon,
      description: 'Horaires & disponibilités',
      color: '#10b981'
    },
    {
      id: 2,
      label: 'Mes Réservations',
      icon: BookingsIcon,
      description: 'Rendez-vous clients',
      color: '#f59e0b',
      badge: pendingBookingsCount > 0 ? pendingBookingsCount : null
    },
    { 
      id: 3, 
      label: 'Abonnement', 
      icon: SubscriptionIcon,
      description: 'Plan & facturation',
      color: '#8b5cf6',
      highlight: userProfile?.subscription?.plan === 'trial'
    },
    { 
      id: 4, 
      label: 'Paramètres', 
      icon: SettingsIcon,
      description: 'Configuration',
      color: '#6b7280'
    }
    // { 
    //   id: 5, 
    //   label: 'Support', 
    //   icon: SupportIcon,
    //   description: 'Aide & contact',
    //   color: '#ef4444'
    // },
  ];

  return (
    <List sx={{ flex: 1, px: 1, py: 1 }}>
      {tabs.map((tab, index) => {
        const Icon = tab.icon;
        const isActive = currentTab === tab.id;
        
        return (
          <ListItem key={tab.id} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              onClick={() => {
                setCurrentTab(tab.id);
                if (isMobile) setMobileOpen(false);
              }}
              sx={{
                borderRadius: 2,
                py: 1,
                px: 1.5,
                bgcolor: isActive ? '#f5f5f4' : 'transparent',
                color: isActive ? '#1c1917' : '#78716c',
                '&:hover': {
                  bgcolor: isActive ? '#e7e5e4' : '#fafaf9',
                  color: '#1c1917'
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              <ListItemIcon sx={{ 
                color: 'inherit', 
                minWidth: 40 
              }}>
                <Box sx={{ position: 'relative' }}>
                  <Icon />
                  {tab.badge && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -6,
                        right: -6,
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        bgcolor: '#ef4444',
                        color: 'white',
                        fontSize: '0.65rem',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px solid white'
                      }}
                    >
                      {tab.badge}
                    </Box>
                  )}
                </Box>
              </ListItemIcon>
              
              <ListItemText 
                primary={tab.label}
                primaryTypographyProps={{
                  fontWeight: isActive ? 600 : 500,
                  fontSize: '0.95rem'
                }}
              />
              
              {tab.highlight && (
                <Chip
                  onClick={() => {}}
                  label="!"
                  size="small"
                  sx={{
                    height: 18,
                    width: 18,
                    minWidth: 18,
                    fontSize: '0.65rem',
                    fontWeight: 700,
                    bgcolor: '#fbbf24',
                    color: 'white',
                    '& .MuiChip-label': { 
                      px: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }
                  }}
                />
              )}
            </ListItemButton>
          </ListItem>
        );
      })}
      
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          @keyframes bounce {
            0%, 20%, 53%, 80%, 100% { transform: translate3d(0,0,0); }
            40%, 43% { transform: translate3d(0,-8px,0); }
            70% { transform: translate3d(0,-4px,0); }
            90% { transform: translate3d(0,-2px,0); }
          }
        `}
      </style>
    </List>
  );
};

export default DrawerNavigation;
